<template>
  <iframe
    :src="src"
    frameborder="0"
    class="iframe"
  />
</template>

<script setup lang="ts">

defineProps<{
  src: string
}>()

</script>

<style>
.iframe {
  width: 100%;
  height: 100vh;
}
</style>
